import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {defineAsyncComponent} from 'vue';
import EventsAndActivityPanel from '@/components/Layout/LayoutV2/EventsAndActivityPanel/EventsAndActivityPanel.vue';
import HealthSuitePanel from '@/components/Layout/LayoutV2/HealthSuitePanel/HealthSuitePanel.vue';
import {useSettingsStore} from '@/api/store/settings';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const settingsStore = useSettingsStore();

const QuickMenu = defineAsyncComponent(() => import('@/components/Layout/LayoutV' + settingsStore.settings.layout + '/QuickMenu.vue'));

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-8",
    style: {"min-height":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(QuickMenu)),
      _createVNode(EventsAndActivityPanel),
      _createVNode(HealthSuitePanel)
    ]),
    _: 1
  }))
}
}

})